//// Application Packages
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components
import StateSelectorComponent from '../conditional-components/state-selector-component'

//// Carbon Components
import {
    TextInput,
    TextArea,
    Select,
    SelectItem,
    DatePicker,
    DatePickerInput,
    Button,
} from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalDisciplineHistoryPendingComponent = ({
    number,
    handleData,
    handleSubtractAdditionalDisciplineHistoryForm,
}) => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']
    const digital_sub_name = 'pending'

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <div>
                <h4>Additional Discipline (Pending):</h4>

                <TextInput
                    className="required"
                    labelText="Name of Agency:"
                    id={'RSD34D' + number}
                    name={'RSD34D' + number}
                    placeholder=""
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'RSD34D' + number
                        ]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'RSD34D' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'RSD34D' + number + 'ErrMsg'
                        ]
                    }
                />

                <StateSelectorComponent
                    digital_name={digital_name}
                    digital_sub_name={digital_sub_name}
                    value_key={['STATED' + number]}
                    country=""
                />

                <DatePicker
                    className="required"
                    dateFormat="m/d/Y"
                    datePickerType="single"
                    onChange={(e) => handleData(e, ['RSD36D' + number])}
                    onClose={(e) => handleData(e, ['RSD36D' + number])}
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'RSD36D' + number
                        ]
                    }
                >
                    <DatePickerInput
                        className="required"
                        labelText="Action Date:"
                        id={'RSD36D' + number}
                        name={'RSD36D' + number}
                        placeholder="MM/DD/YYYY"
                        type="text"
                        invalid={
                            formsData?.[digital_name]?.[digital_sub_name]
                                ?.errors?.['RSD36D' + number]
                        }
                        invalidText={
                            formsData?.[digital_name]?.[digital_sub_name]
                                ?.errors?.['RSD36D' + number + 'ErrMsg']
                        }
                    />
                </DatePicker>

                <TextInput
                    className="required"
                    labelText="Final Action:"
                    id={'FIN_ACTD' + number}
                    name={'FIN_ACTD' + number}
                    placeholder=""
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'FIN_ACTD' + number
                        ]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'FIN_ACTD' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'FIN_ACTD' + number + 'ErrMsg'
                        ]
                    }
                />

                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'RSD39D' + number
                        ]
                    }
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'RSD39D' + number
                        ]
                    }
                    helper=""
                    labelText="Under Appeal:"
                    id={'RSD39D' + number}
                    name={'RSD39D' + number}
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'RSD39D' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'RSD39D' + number + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="Yes" value="Y" />
                    <SelectItem text="No" value="N" />
                    <SelectItem text="No Answer" value="NA" />
                </Select>

                <TextArea
                    className="required"
                    labelText="Applicant Statement:"
                    id={'LIC_NTSD' + number}
                    name={'LIC_NTSD' + number}
                    placeholder=""
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'LIC_NTSD' + number
                        ]
                    }
                    maxLength="4000"
                    type="textarea"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'LIC_NTSD' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'LIC_NTSD' + number + 'ErrMsg'
                        ]
                    }
                />

                <div className="half-width-button-with-icon-group">
                    <div className="half-width-button-with-icon-group-item">
                        <Button
                            className="fldoh-btn"
                            name={number}
                            type="button"
                            kind="danger"
                            size="md"
                            onClick={
                                handleSubtractAdditionalDisciplineHistoryForm
                            }
                        >
                            Remove
                            <Subtract />
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdditionalDisciplineHistoryPendingComponent
